import { Button }   from 'semantic-ui-react'
import { Form }     from 'semantic-ui-react'
import { Grid }     from 'semantic-ui-react'

import PageHeader from "../Components/pageHeader";
import { userLoginRequest, userDataRequest } from '../api/backend';
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from '../Components/userContext';
import { displayErrors } from "../Components/displayNotifications";

import TextField from '../Components/TextField.jsx'

export default function Login(properties) {

    const { setSession } = properties;
    const navigate = useNavigate();

    const setSentinel = useContext(UserContext).setSentinel;
    const setLoadingUserContext = useContext(UserContext).setLoading;

    const [invalid, setInvalid] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmitLogin = async (e) => {

        e.preventDefault();
        setLoading(true);

        // let hasError = false;

        if (!e.target.checkValidity()) {
            setInvalid(true);
            setLoading(false);
            return null;
        }

        const formData = new FormData (e.target)

        const loginRequest = await userLoginRequest(formData);

        if ([200, 201, 204].includes(loginRequest.status)) {


            const loginData = await loginRequest.json();

            setSession({
                "token": loginData.accessToken,
                "userId": loginData.userId,
            })

            setLoadingUserContext(true);
            setSentinel(Symbol());

            navigate('/');

        } else {
            const response = await loginRequest.json();
            displayErrors(response);
        }

        setLoading(false);

    }

    return (
        <div className="ui container" style={{ marginTop: '2em' }}>
            <PageHeader
                title={"Login"}
                icon={"user"}
            />
            <div style={{ marginTop: '2em' }}>
                <Form onSubmit={handleSubmitLogin}>
                    <Grid>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <TextField { ... {
                                    autoFocus:      true,
                                    icon:           'user',
                                    iconPosition:   'left',
                                    label:          'Email address',
                                    name:           'emailAddress',
                                    readOnly:       loading,
                                    required:       true,
                                    type:           'email'
                                } } />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <TextField { ... {
                                    icon:           'lock',
                                    iconPosition:   'left',
                                    label:          'Password',
                                    name:           'password',
                                    readOnly:       loading,
                                    required:       true,
                                    type:           'password'
                                } } />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <Button
                                    color="orange"
                                    disabled={loading}
                                    type="submit"
                                >
                                    Log in
                                </Button>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <a href="/sign-up">Sign up</a>
                                <a href="/forgot-password">Forgot password</a>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </div>
        </div>
    )
}
